import { render, staticRenderFns } from "./badMen.vue?vue&type=template&id=52a2a294&scoped=true"
import script from "./badMen.vue?vue&type=script&lang=js"
export * from "./badMen.vue?vue&type=script&lang=js"
import style0 from "./badMen.vue?vue&type=style&index=0&id=52a2a294&prod&scoped=true&lang=css"
import style1 from "./badMen.vue?vue&type=style&index=1&id=52a2a294&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a2a294",
  null
  
)

export default component.exports